// 根据环境变量设置 BaseUrl
let BaseUrl = 'http://127.0.0.1:5656'; // 开发环境默认值
// let BaseUrl = 'https://sorting-api.lengfenghl.com.cn'; // 开发环境默认值

if (process.env.NODE_ENV === 'production') {
	// 生产环境根据 VUE_APP_ENV 区分
	if (process.env.VUE_APP_ENV === 'test') {
		BaseUrl = 'http://sorting-test-api.lengfenghl.com.cn';
	} else {
		BaseUrl = 'https://sorting-api.lengfenghl.com.cn';
	}
}

export { BaseUrl };

